import { Base, base } from "./base"

export type Colors = Base

export const colors: Colors = {
  ...base
}
